import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const DEFAULT_LABELS = {
  kanban: {
    nuevo: "Nuevo", calificando: "Calificando", calificado: "Calificado",
    cotizado: "Cotizado", archivado: "Archivado",
  },
  pipeline: {
    interesado: "Muy interesado", posible_cierre: "Venta en 7 días",
    ganado: "Ganado", perdido: "Perdido",
  },
};

export function useCrmLabels() {
  const q = useQuery({
    queryKey: ["crm-labels"],
    queryFn: async () => (await api.get("/crm-config/labels")).data,
    staleTime: 5 * 60 * 1000,
  });
  const data = q.data || DEFAULT_LABELS;
  return {
    kanban: { ...DEFAULT_LABELS.kanban, ...(data.kanban || {}) },
    pipeline: { ...DEFAULT_LABELS.pipeline, ...(data.pipeline || {}) },
    isLoading: q.isLoading,
  };
}

export function useGcalStatus() {
  return useQuery({
    queryKey: ["gcal-status"],
    queryFn: async () => (await api.get("/gcal/status")).data,
    staleTime: 60 * 1000,
  });
}

export const fmtReminder = (s) => {
  if (!s) return "";
  try {
    return new Date(s).toLocaleString("es-ES", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return s;
  }
};

// datetime-local por defecto: mañana a las 10:00
export const defaultReminderWhen = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(10, 0, 0, 0);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
